<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-navigator';

  export let path = '';
  export let config = {};

  onMount(() => navigate(path, config));
</script>
